import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { GoogleMap, LoadScript, Marker, Autocomplete } from '@react-google-maps/api';

const libraries = ['places'];
const region = ['PH'];

const UpdateLocation = ({ formData, setFormData }) => {

  const autocompleteRef = useRef()

  const getUserGeoLocation = () => {
    if (_.get(formData, 'pinned_geolocation')) {
      const [lat, lng] = _.get(formData, 'pinned_geolocation').split(',')
      return {
        lat: +lat,
        lng: +lng
      }
    }

    return {
      lat: 14.5964957,
      lng: 120.9445404
    }
  }

  const onLoadAutoComplete = (autocomplete) => {
    autocompleteRef.current = autocomplete
  }

  const onPlaceChanged = () => {
    if (autocompleteRef.current) {
      const { lat, lng } = autocompleteRef.current.getPlace().geometry.location.toJSON()
      setFormData({
        ...formData,
        pinned_geolocation: `${lat},${lng}`
      });
    }
  }

  const onClickOnMap = e => {
    const { lat, lng } = e.latLng.toJSON()
    setFormData({
      ...formData,
      pinned_geolocation: `${lat},${lng}`
    });
  }

  return (
    <div className="p-3">
      <LoadScript
        region={region}
        libraries={libraries}
        googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAP_KEY}
      >
        <GoogleMap
          onClick={onClickOnMap}
          mapContainerStyle={{
            width: '100%',
            height: '400px',
          }}
          center={getUserGeoLocation()}
          zoom={12}
        >
          <Autocomplete
            onLoad={onLoadAutoComplete}
            onPlaceChanged={onPlaceChanged}
            restrictions={{ country: "ph" }}
            fields={["geometry"]}
          >
            <input
              type="text"
              placeholder="Search Location..."
              style={{
                boxSizing: `border-box`,
                border: `1px solid transparent`,
                width: `300px`,
                height: `32px`,
                padding: `0 12px`,
                borderRadius: `3px`,
                boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                fontSize: `14px`,
                outline: `none`,
                textOverflow: `ellipses`,
                position: "absolute",
                // left: "50%",
                // marginLeft: "-120px",
                top: "60px",
                left: "10px"
              }}
            />
          </Autocomplete>
          <Marker position={getUserGeoLocation()} />
        </GoogleMap>
      </LoadScript>
    </div>
  );
};

UpdateLocation.propTypes = {
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
};

export default UpdateLocation;
